<template lang="html">

  <header class="header" :min="min">

    <div class="top row-between">

      <div class="right row-start">
        <router-link to="/">
          <img width="200" class="logo" src="/static/img/logo-color.png" alt="LOGO USAL"></router-link>
      </div>

      <div class="left row-end">

        <a :href="$t('portalalumno')" class="btn -small" target="_blank">Acceso Estudiantes/Titulados</a>
        <a :href="$t('portalempresas')" class="btn -small" target="_blank">Acceso Empresas</a>
        

        <button class="show-menu column-start" @click="showmenu = true">
          <span></span>
          <span></span>
          <span></span>
        </button>

      </div>

    </div>

    <div class="bottom row-center" :show="showmenu">

      <div class="left row-center">
        <router-link to="/">
          <img src="/static/img/logo-vertical-blanco.svg" alt="Logo USAL">
        </router-link>
      </div>
      <div class="right column-center">
        <a @click="showmenu = false" class="close-menu">✕</a>
        <div class="contenedor-enlaces column-start">
          <router-link to="/" class="logo">
            <img width="60" src="/static/img/logo-vertical-blanco.svg" alt="logo">
          </router-link>
          <router-link to="/">Inicio</router-link>
          <router-link :to="$t('enlaces.programas')">Programas</router-link>
          <router-link :to="$t('enlaces.ofertas')">Ofertas</router-link>
          <router-link :to="$t('enlaces.faqs')">Preguntas frecuentes</router-link>
          <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
          <a :href="$t('portalalumno')" target="_blank" class="btn">Acceder</a>
        </div>
      </div>

    </div>

  </header>

</template>

<script lang="js">
  export default {
    name: 'app-header',
    mounted() {
      this.min = ($(window).scrollTop() >= 180);
      $(window).scroll(e => {
        this.min = ($(window).scrollTop() >= 180);
      });
    },
    data() {
      return {
        showmenu: false,
        min: false,
        childs : {
          servicios : false
        }
      }
    },
    computed:{
      inServicios(){
        let names = ['tutores','titulados','empresas'];
        return (names.some(n => n == this.$route.name));
      }
    },
    watch: {
      '$route'() {
        this.showmenu = false;
        this.childs.servicios = false;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/parts/header.vue